  <template>
  <f7-page>
    <f7-navbar :no-shadow="true">
      <f7-nav-left>
        <a class="link color-theme-white popup-close" href="#">
          <i class="icon icon-back"></i>
          <span>返回</span>
        </a>
      </f7-nav-left>
      <f7-nav-title>选择项目</f7-nav-title>
    </f7-navbar>
    <f7-searchbar
      ref="lplSeachbar"
      custom-search
      disable-button-text="取消"
      placeholder="请输入项目名称"
      @searchbar:search="searchProjectList">
    </f7-searchbar>
    <div
      class="has-content"
      style="text-align: center;"
      v-if="projectList.length === 0">
      暂无数据
    </div>
    <div class="has-content" v-else>
      <f7-list
        media-list
        virtual-list>
        <f7-list-item v-for="item in projectList" :key="item.id">
          <div slot="inner" class="project-item" v-if="independent">
            <a class="link popup-close" :href="`/workLog/log/${item.id}?name=${item.name}`">
              <div class="project-text">
                {{ item.name }}
              </div>
            </a>
          </div>
          <div slot="inner" class="project-item" v-else>
            <a class="link popup-close" href="#" @click="selectProject(item)">
              <div :class="item.id === project.id? 'project-text-active' : 'project-text'">
                {{ item.name }}
              </div>
            </a>
          </div>
        </f7-list-item>
      </f7-list>
    </div>
  </f7-page>
</template>
<script>

import { getWorkProjectList } from '@/api/workLog';
import lodash from 'lodash';

export default {
  props: ['opened', 'project', 'independent'],
  data() {
    return {
      name: '',
      projectList: [],
    };
  },
  created() {
    this.debouncedGetList = lodash.debounce(this.getList, 500);
  },
  watch: {
    opened(val) {
      if (val) {
        this.getList();
        if (this.$refs.lplSeachbar) {
          this.$refs.lplSeachbar.disable();
        }
      }
    },
    name() {
      this.debouncedGetList();
    },
  },
  methods: {
    getList() {
      const params = {
        name: this.name,
      };
      getWorkProjectList(params).then((result) => {
        if (result.code === 0) {
          this.projectList = result.data || [];
        }
      });
    },
    searchProjectList(searchbar, query, previousQuery) {
      if (query !== previousQuery) {
        this.name = query;
      }
    },
    selectProject(project) {
      this.$emit('update:project', { id: project.id, name: project.name, date: this.project.date });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .project-item {
    padding-left: 0.5rem;
    font-size: 1rem;
    width: 100%;
  }

  .project-text {
    color: $font-color;
  }

  .project-text-active {
    color: $second-color;
  }

</style>



// WEBPACK FOOTER //
// src/components/LogProjectList.vue